import { useEffect, useRef, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Flex,
  Spin,
  message,
  Space,
  Drawer,
  Typography,
} from "antd";
import { PrinterOutlined, SyncOutlined } from "@ant-design/icons";
import { ReadyToPrint } from "../ReadyToPrint";
import { HairForm } from "./azeem";
import "./index.css";
import OuthPrint from "../outh_print";
import { CitiesTextEditor } from "../../textEditor";
import { CitiesInput } from "../../input";
import { postsessioninstruction } from "../../../services/postsessioninstruction";

// const PrintForm = ({ prpSessions, fueAppointmentDate }) => {
//   return (
//     <HairForm
//       prpSessions={prpSessions}
//       fueAppointmentDate={fueAppointmentDate}
//     />
//   );
// };
const { Text } = Typography;
const PostOperationInstructions = ({ visible, clientInfo, onClose }) => {
  const printRef = useRef();
  const [form] = Form.useForm();
  const [editedConsent, setEditedConsent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const clientDetails = clientInfo?.appointment?.client_info;
  useEffect(() => {
    if (visible && clientInfo) {
      form.setFieldsValue({
        name: clientDetails?.name,
        age: clientDetails?.age,
        city: clientDetails?.address,
        fatherName: clientDetails?.fatherName,
        // consent: clientDetails?.consentFormDelta,
      });
      getAllPostSessionInstructions();
    }
  }, [clientInfo, visible]);

  const getAllPostSessionInstructions = async () => {
    setLoading(true);
    const postId = clientInfo?.postId;
    const res = await postsessioninstruction.getPostSessionSingle(postId);

    if (res) {
      const instruction = res?.instruction;
      form.setFieldsValue({ consent: instruction });
      setData(instruction);
      setEditedConsent(instruction);
    } else {
      message.error("Failed to load instructions");
    }
    setLoading(false);
  };

  return (
    <Drawer
      // width={"793.92px"}
      title="Post Operation Instructions"
      width={800}
      onClose={onClose}
      open={visible}
      destroyOnClose
      footer={
        <Flex gap={5}>
          <Button
            style={{ background: "#2F80ED" }}
            className="text-white border-0"
            icon={<PrinterOutlined />}
            onClick={() => {
              printRef.current?.(); // safely call print
            }}
          >
            Print
          </Button>
          <Button onClick={onClose}>Close</Button>
        </Flex>
      }
    >
      {/* Main Content Area */}

      <Form layout="vertical" form={form} requiredMark={false}>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <CitiesInput
              name="name"
              label="Name"
              required
              placeholder="Your Name"
              disabled
            />
          </Col>
          <Col span={12}>
            <CitiesInput
              name="fatherName"
              label="Father Name"
              required
              placeholder="Father Name"
              disabled
            />
          </Col>
          <Col span={12}>
            <CitiesInput
              name="age"
              disabled
              label="Age"
              required
              placeholder="Age"
            />
          </Col>
          <Col span={12}>
            <CitiesInput
              name="city"
              label="Address"
              required
              placeholder="City"
              disabled
            />
          </Col>
          <Col span={24}>
            {loading ? (
              <Flex justify="center" align="center" style={{ height: "200px" }}>
                <Spin
                  size="large"
                  indicator={
                    <SyncOutlined
                      spin
                      style={{ color: "var(--main-color)", fontSize: "24px" }}
                    />
                  }
                />
              </Flex>
            ) : (
              <CitiesTextEditor
                disabled
                name="consent"
                label="Instruction"
                required
                onChange={(val) => {
                  setEditedConsent(val); // ✅ change track karo
                  form.setFieldsValue({ consent: val });
                }}
              />
            )}
          </Col>
        </Row>
      </Form>
      {/* Hidden Print Component - Matches exact design */}
      <div className="hidden">
        <ReadyToPrint
          print={printRef}
          name="Post-Operation Instructions"
          Component={
            <div>
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  padding: "3px 8px",
                  marginBottom: 5,
                  background: "#f9f9f9",
                  marginBottom: 20,
                }}
              >
                <Row gutter={[8, 1]}>
                  <Col span={24}>
                    <Text style={{ fontSize: 10 }} strong>
                      MRN:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {clientDetails?.mrn ?? "N/A"}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Name:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {clientDetails?.name ?? "N/A"}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Father's Name:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {clientDetails?.fatherName ?? "N/A"}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Age:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {clientDetails?.age ?? "N/A"}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Address:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {clientDetails?.address ?? "N/A"}
                    </Text>
                  </Col>
                </Row>
              </div>
              <div
                ref={(el) => {
                  if (el) {
                    el.querySelectorAll(".ql-align-center").forEach((item) => {
                      item.style.setProperty(
                        "text-align",
                        "center",
                        "important",
                      );
                    });
                    el.querySelectorAll(".ql-align-right").forEach((item) => {
                      item.style.setProperty(
                        "text-align",
                        "right",
                        "important",
                      );
                    });
                    el.querySelectorAll(".ql-align-justify").forEach((item) => {
                      item.style.setProperty(
                        "text-align",
                        "justify",
                        "important",
                      );
                    });
                  }
                }}
                dangerouslySetInnerHTML={{
                  __html: editedConsent,
                }}
                style={{ marginTop: 10 }}
              ></div>
            </div>
          }
        />
      </div>
    </Drawer>
  );
};

export { PostOperationInstructions };
